import { useEffect, useMemo, useState } from 'react';
import styles from './rating.module.css';
import TabsRating from '../../components/TabsRating/TabsRating';
import RatingTable from '../../components/RatingTable/RatingTable';
import { getTeamsRating, getAllUsersRating } from '../../api/ratings';
import avatarPlaceholder from '../../assets/icons/avatar.svg';
import { buildDisplayName } from '../../utils/userDisplay';

export const Rating = () => {
  const [activeTab, setActiveTab] = useState('members');
  const [activeTrack, setActiveTrack] = useState('ALL');
  const [members, setMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [teamTracks, setTeamTracks] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    async function loadRatings() {
      try {
        setError('');
        const [usersRating, teamsRating] = await Promise.all([
          getAllUsersRating(),
          getTeamsRating(100, 0)
        ]);

        setMembers(
          usersRating.map((item) => ({
            id: item.user_id || `result-${item.result_id}`,
            name: item.full_name || buildDisplayName(item),
            rank: item.rank_position,
            pendingAccount: !item.user_id,
            login: item.login,
            team: item.team_name,
            balance: item.balance,
            ratingScore: item.rating_score ?? item.balance,
            avatar: item.avatar_url || avatarPlaceholder
          }))
        );

        const tracks = Array.from(
          new Set(
            teamsRating
              .map((item) => item.track_label)
              .filter(Boolean)
          )
        );
        setTeamTracks(tracks);
        setTeams(
          teamsRating.map((item) => ({
            id: item.team_id,
            teamName: item.name,
            rank: item.rank_position,
            balance: item.balance,
            ratingScore: item.rating_score ?? item.balance,
            trackLabel: item.track_label || '',
            captainLogin: item.captain_login || '-',
            avatar: item.avatar_url || avatarPlaceholder
          }))
        );
      } catch (err) {
        setError(err.message);
      }
    }

    loadRatings();
  }, []);

  useEffect(() => {
    if (activeTab !== 'teams') return;
    async function loadTeamsRating() {
      try {
        setError('');
        const teamsRating = await getTeamsRating(100, 0, activeTrack === 'ALL' ? '' : activeTrack);
        setTeams(
          teamsRating.map((item) => ({
            id: item.team_id,
            teamName: item.name,
            rank: item.rank_position,
            balance: item.balance,
            ratingScore: item.rating_score ?? item.balance,
            trackLabel: item.track_label || '',
            captainLogin: item.captain_login || '-',
            avatar: item.avatar_url || avatarPlaceholder
          }))
        );
      } catch (err) {
        setError(err.message);
      }
    }
    loadTeamsRating();
  }, [activeTab, activeTrack]);

  const tableData = useMemo(
    () => (activeTab === 'members' ? members : teams),
    [activeTab, members, teams]
  );

  return (
    <div>
      <h1 className={styles.title}>Рейтинг</h1>
      <TabsRating activeTab={activeTab} onTabChange={setActiveTab} />
      {activeTab === 'teams' && teamTracks.length ? (
        <div className={styles.trackTabs}>
          <button
            type="button"
            className={`${styles.trackTab} ${activeTrack === 'ALL' ? styles.trackTabActive : ''}`}
            onClick={() => setActiveTrack('ALL')}
          >
            Все треки
          </button>
          {teamTracks.map((track) => (
            <button
              key={track}
              type="button"
              className={`${styles.trackTab} ${activeTrack === track ? styles.trackTabActive : ''}`}
              onClick={() => setActiveTrack(track)}
            >
              {track}
            </button>
          ))}
        </div>
      ) : null}
      {error && <p>{error}</p>}
      <RatingTable type={activeTab} data={tableData} />
    </div>
  );
};
